import React, { Component } from 'react';
import Page from '../components/Page';
import { Button, Checkbox, Container, FormControlLabel, FormGroup, Input, Paper } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import _ from 'lodash';

const platforms = [
	{
		name: 'Instagram',
	},
	{
		name: 'Facebook Messenger',
	},
	{
		name: 'WhatsApp Business API',
	},
];
class Survey extends Component {
	state = { array: [], other: false };
	handleChange = (e, { name, value }) => this.setState({ [name]: value });
	handleFilterCheck(value) {
		let array = this.state.array;
		let exists = _.includes(array, value);
		let valueArr = exists ? _.filter(array, (it) => it !== value) : _.concat([], array, value);
		this.setState({ array: valueArr });
	}
	render() {
		let message = 'Select at least one platform.';
		if (this.state.array.length && !this.state.otherText) {
			message = 'I want to see these platforms; ' + this.state.array.join(', ') + '.';
		} else if (this.state.array.length && this.state.otherText && this.state.other) {
			message = 'I want to see these platforms; ' + this.state.array.join(', ') + ', ' + this.state.otherText + '.';
		} else if (!this.state.array.length && this.state.otherText && this.state.other) {
			message = 'I want to see these platforms; ' + this.state.otherText + '.';
		} else if (this.state.array.length && !this.state.other) {
			message = 'I want to see these platforms; ' + this.state.array.join(', ') + '.';
		}
		return (
			<Page title="Survey" icon={<HelpOutlineIcon />}>
				<Page.Wrap>
					<Container>
						<Paper evelation={20} sx={{ padding: '15px' }}>
							<h3 style={{ textAlign: 'center' }}>Which platforms would you like to connect?</h3>
							<p>Select plaform or platforms and send us via WhatsApp.</p>
							<FormGroup >
								{_.map(platforms, (it) => (
									<FormControlLabel control={<Checkbox name={it.name} onChange={() => this.handleFilterCheck(it.name)} />} label={it.name} />
								))}
								<FormControlLabel
									control={<Checkbox name={'other'} value={!this.state.other} onChange={this.handleChange} />}
									label={'Others'}
								/>

								{this.state.other ? (
									<Input name="otherText" onChange={this.handleChange} placeholder="Enter other platforms you want"></Input>
								) : null}
								<p>{message}</p>
								<Button
									disabled={message === 'Select at least one platform.'}
									as="a"
									href={'https://api.whatsapp.com/send?phone=908503464798&text=' + message}
									sx={{ target: '_blank' }}
									color={'primary'}
									icon="whatsapp"
								>
									Send
								</Button>
							</FormGroup>
						</Paper>
					</Container>
				</Page.Wrap>
			</Page>
		);
	}
}

export default Survey;
